import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { authApi } from "../../api/auth";
import BrandHeader from "../BrandHeader";

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation("auth");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try { await authApi.forgotPassword(email); } catch {}
    setSent(true);
    setLoading(false);
  };

  if (sent) {
    return (
      <div className="min-h-screen bg-[#050505]">
        <BrandHeader />
        <div className="flex items-center justify-center min-h-[calc(100vh-6rem)] px-6">
          <div className="w-full max-w-md feature-card p-8 rounded-lg text-center">
            <h1 className="font-clash text-2xl font-bold text-white mb-4">{t("forgotPassword.sentTitle")}</h1>
            <p className="text-[#A1A1AA] mb-6">{t("forgotPassword.sentBody", { email })}</p>
            <Link to="/login" className="text-[#FF5500] hover:text-[#FF7733] text-sm">{t("forgotPassword.backToLogin")}</Link>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#050505]">
      <BrandHeader />
      <div className="flex items-center justify-center min-h-[calc(100vh-6rem)] px-6">
        <div className="w-full max-w-md feature-card p-8 rounded-lg">
        <h1 className="font-clash text-2xl font-bold text-white mb-6 text-center">{t("forgotPassword.title")}</h1>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="font-mono text-xs uppercase tracking-wider text-[#A1A1AA] block mb-2">{t("forgotPassword.emailLabel")}</label>
            <input type="email" value={email} onChange={(e) => setEmail(e.target.value)}
              className="w-full bg-[#1a1a1e] border border-white/10 rounded px-4 py-3 text-white focus:border-[#FF5500] focus:outline-none transition-colors" required />
          </div>
          <button type="submit" disabled={loading} className="btn-primary w-full py-3 rounded text-sm font-semibold disabled:opacity-50">
            {loading ? t("forgotPassword.submitting") : t("forgotPassword.submit")}
          </button>
        </form>
        <p className="text-center text-sm text-[#A1A1AA] mt-6">
          <Link to="/login" className="text-[#FF5500] hover:text-[#FF7733]">{t("forgotPassword.backToLogin")}</Link>
        </p>
        </div>
      </div>
    </div>
  );
}
